import CheckAuth from "app/components/check-auth";
import { FcfsStage, useIdoFcfsStage } from "app/hooks";
import cn from "classnames";
import { FC } from "react";
import { Ido } from "sdk";
import { CheckNetwork } from "../../project/check-network/check-network";
import ProjectLose from "../../project/project-lose";
import ProjectSwap__Success from "../../project/project-swap/project-swap__success";
import IdoFcfs__Body from "./ido-fcfs__body";
import IdoFcfs__Buttons from "./ido-fcfs__buttons";
import IdoFcfs__Success from "./ido-fcfs__sucess";

type Props = {
  className?: string;
  ido: Ido;
};

const IdoFcfs: FC<Props> = ({ className = "", ido }) => {
  const fcfsStage = useIdoFcfsStage(ido);

  return (
    <div className={cn("project-swap", className)}>
      <div className="project-swap__title">FCFS</div>
      <CheckAuth className="project-swap__connect">
        <CheckNetwork project={ido} className="project-swap__network">
          {fcfsStage === FcfsStage.F1_HAS_NO_APP && <ProjectLose type="no-application" />}

          {fcfsStage === FcfsStage.F2_HAS_APP_NOT_REDEEM && (
            <>
              <ProjectSwap__Success project={ido} />
              <IdoFcfs__Body ido={ido} />
              <IdoFcfs__Buttons ido={ido} />
            </>
          )}

          {fcfsStage === FcfsStage.F3_HAS_APP_REDEEM && <IdoFcfs__Success ido={ido} />}
        </CheckNetwork>
      </CheckAuth>
    </div>
  );
};

export default IdoFcfs;
